import { observer } from 'mobx-react'

import './footer.scss'

export const Footer = observer(() => {
  return <div className="Footer">Footer</div>
})
